import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router/';

@Component({
  selector: 'app-edit-charter-customer-info-heading',
  templateUrl: './edit-charter-customer-info-heading.component.html',
  styleUrls: ['./edit-charter-customer-info-heading.component.scss'],
})
export class EditCharterCustomerInfoHeadingComponent implements OnInit {
  @Input()
  userId: number;

  constructor(private router: Router) {}

  ngOnInit() {}

  userIdClick(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['manage/admin/user/edit/', this.userId]),
    );
    window.open(url, '_blank');
  }
}
